import { gql } from "@apollo/client";

export const messageHeaders = gql`
  fragment messageHeaders on MessageHeaders {
    nbbCorrelationId
  }
`;
